import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaCaretUp, FaCaretDown, FaBell } from "react-icons/fa6";
import { ActionIcon } from "@mantine/core";
import { FaSun, FaMoon } from "react-icons/fa";
import {
  EthTokenIcon,
  BscTokenIcon,
  SolTokenIcon,
  AvaxTokenIcon,
  PolygonTokenIcon,
  ArbitrumTokenIcon,
} from "../../utils/tokens/svgs";
import FormattedNumber from "../../utils/fixPrice";
import calculatePercentageChange from "../../utils/percentageMove";
import BigValueFormatter from "../../utils/bigNumbers";
import { Link } from "react-router-dom";
import LogoFreshCoinsLight from "../../assets/images/freshcoins_logo_var-03.svg";
import LogoFreshCoinsDark from "../../assets/images/freshcoins_logo_var-04.svg";

const HeaderProject = ({
  isScrolled,
  project,
  toggleColorScheme,
  computedColorScheme,
  activeTab,
  handleTabClick,
  currentProject,
}) => {
  return (
    <>
      <header
        className={`
      ${
        !isScrolled
          ? "hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light dark:bg-background-dark sticky z-sticky top-0"
          : "hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light-80 dark:bg-background-dark-80 sticky z-sticky top-0"
      }`}
      >
        <div className="flex h-[5rem] w-full items-center justify-between gap-8">
          <div className="flex min-w-0 shrink items-center gap-2 text-neutral-100 dark:text-neutral-0">
            {!isScrolled ? (
              <div className="flex items-center gap-2">
                <Link className="relative shrink-0" to="/">
                  <img
                    src={
                      computedColorScheme === "dark"
                        ? LogoFreshCoinsLight
                        : LogoFreshCoinsDark
                    }
                    width="180px"
                    style={{ marginLeft: "-12px", position: "relative" }}
                  />
                  <span className="logo-text">AUDITS</span>
                </Link>
              </div>
            ) : (
              <div
                class={`min-w-0 shrink grow ${
                  isScrolled ? "opacity-100" : ""
                } opacity-0`}
                data-projection-id="184"
              >
                <div class="flex h-fit w-full flex-row items-center gap-4">
                  <div class="flex h-fit w-fit items-center justify-between gap-2 overflow-hidden">
                    <div class="flex shrink-0 items-center">
                      <div
                        class="relative flex w-fit shrink-0 items-center justify-center overflow-hidden rounded-full"
                        style={{ height: "32px", width: "32px" }}
                      >
                        <img
                          alt="Bitcoin logo"
                          loading="lazy"
                          width="32"
                          height="32"
                          decoding="async"
                          data-nimg="1"
                          class=""
                          srcset={currentProject?.logo}
                          style={{ color: "transparent" }}
                        />
                      </div>
                    </div>
                    <div class="truncate font-semibold text-neutral-100 dark:text-neutral-0 text-xl">
                      {currentProject?.name}
                    </div>
                    <div class="flex min-w-0 shrink items-center gap-2">
                      <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs">
                        {currentProject?.symbol}
                      </div>
                      <div class="text-neutral-100 dark:text-neutral-0 flex items-center gap-2">
                        <div
                          className={`flex h-full items-center text-sm font-medium text-neutral-100 transition-colors  dark:text-neutral-0 text-score-good-background `}
                        >
                          {currentProject?.network === 56 ? (
                            <BscTokenIcon size={20} />
                          ) : currentProject?.network === 1 ? (
                            <EthTokenIcon size={20} />
                          ) : currentProject?.network === 69 ? (
                            <SolTokenIcon size={20} />
                          ) : currentProject?.network === 43114 ? (
                            <AvaxTokenIcon size={20} />
                          ) : currentProject?.network === 137 ? (
                            <PolygonTokenIcon size={20} />
                          ) : currentProject?.network === 42161 ? (
                            <ArbitrumTokenIcon size={20} />
                          ) : null}
                        </div>
                        <div class="flex gap-2">
                          <div
                            class={`${
                              currentProject?.score < 80 &&
                              currentProject?.score > 70
                                ? "text-score-poor"
                                : currentProject?.score < 70
                                ? "text-score-alert"
                                : "text-score-excellent"
                            } flex w-10 justify-center rounded bg-current font-semibold py-0.5 text-xs`}
                          >
                            <div class="leading-3">
                              <span class="text-xs text-neutral-0">
                                {currentProject?.score}
                              </span>
                              <span class="text-2xs text-neutral-0">.00</span>
                            </div>
                          </div>
                          <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs">
                            Pre-Launch
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="opacity-100">
            {isScrolled ? (
              <div className="flex items-center gap-4">
                <div className="relative flex h-10 items-center">
                  <div className="flex items-center gap-2">
                    <span class="hidden whitespace-nowrap text-xs font-semibold text-n-50 lg:flex">
                      Token Price (24H)
                    </span>
                    <span class="font-semibold text-n-100">
                      <FormattedNumber
                        number={currentProject?.priceUsd?.toFixed(24)}
                      />
                    </span>
                    {currentProject?.priceUsd24hAgo?.toFixed(24) ? (
                      <div
                        class={`flex w-fit items-center rounded text-xs font-semibold text-neutral-0 px-1 py-0.5 h-fit self-center  ${
                          currentProject?.priceUsd?.toFixed(24) >
                          currentProject?.priceUsd24hAgo?.toFixed(24)
                            ? "bg-success-main"
                            : "bg-primary-main"
                        }`}
                      >
                        {currentProject?.priceUsd24hAgo?.toFixed(24) ===
                        undefined ? (
                          <span></span>
                        ) : (
                          <div
                            className={`flex w-fit items-center rounded  bg-transparent font-medium text-sm`}
                          >
                            {currentProject?.priceUsd?.toFixed(24) >
                            currentProject?.priceUsd24hAgo?.toFixed(24) ? (
                              <FaCaretUp />
                            ) : (
                              <FaCaretDown />
                            )}
                            {calculatePercentageChange(
                              currentProject?.priceUsd?.toFixed(24),
                              currentProject?.priceUsd24hAgo?.toFixed(24)
                            )}
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <ActionIcon variant="light" color="gray" size="lg">
                  <FaBell />
                </ActionIcon>
                <ActionIcon
                  variant="light"
                  color="gray"
                  size="lg"
                  onClick={toggleColorScheme}
                >
                  {computedColorScheme === "dark" ? <FaSun /> : <FaMoon />}
                </ActionIcon>
              </div>
            )}
          </div>
        </div>
      </header>
      <header
        className="hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light dark:bg-background-dark relative z-[1019]"
        style={{ minHeight: 68 }}
      >
        <div className="flex h-fit w-full flex-nowrap items-center justify-between gap-4 pb-2 sm:pb-4">
          <div className="flex min-w-0 shrink items-center gap-4">
            <div className="min-w-0 shrink">
              <div className="relative w-full">
                {currentProject?.priceUsd?.toFixed(24) ? (
                  <div className="max-w-full overflow-y-hidden overflow-x-scroll scroll-smooth scrollbar-hide">
                    <div className="flex h-full gap-3 items-center">
                      <div className="flex flex-col justify-between">
                        <div className="flex gap-1">
                          <div class="truncate text-xs font-medium text-neutral-60 dark:text-neutral-40">
                            Token Price
                          </div>
                          <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-2xs">
                            24h
                          </div>
                        </div>
                        <div className="my-auto flex items-center gap-2">
                          <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                            <FormattedNumber
                              number={currentProject?.priceUsd?.toFixed(24)}
                            />
                          </div>
                          {currentProject?.priceUsd24hAgo?.toFixed(24) ? (
                            <div
                              class={`flex h-fit items-center gap-1 rounded-md px-1 py-0.5 text-sm font-medium text-neutral-0  ${
                                currentProject?.priceUsd?.toFixed(24) >
                                currentProject?.priceUsd24hAgo?.toFixed(24)
                                  ? "bg-success-main"
                                  : "bg-primary-main"
                              }`}
                            >
                              {currentProject?.priceUsd24hAgo?.toFixed(24) ===
                              undefined ? (
                                <span></span>
                              ) : (
                                <div
                                  className={`flex w-fit items-center rounded  bg-transparent font-medium text-sm`}
                                >
                                  {currentProject?.priceUsd?.toFixed(24) >
                                  currentProject?.priceUsd24hAgo?.toFixed(
                                    24
                                  ) ? (
                                    <FaCaretUp />
                                  ) : (
                                    <FaCaretDown />
                                  )}
                                  {calculatePercentageChange(
                                    currentProject?.priceUsd?.toFixed(24),
                                    currentProject?.priceUsd24hAgo?.toFixed(24)
                                  )}
                                </div>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="mb-1 w-px shrink-0 bg-neutral-20 dark:bg-neutral-80 h-[48px]"></div>
                      <div className="flex flex-col justify-between">
                        <div className="flex gap-1">
                          <div class="truncate text-xs font-medium text-neutral-60 dark:text-neutral-40">
                            Market Cap
                          </div>
                          <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-2xs">
                            24h
                          </div>
                        </div>
                        <div className="my-auto flex items-center gap-1">
                          <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                            <BigValueFormatter
                              value={currentProject?.marketCapUsd}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="mb-1 w-px shrink-0 bg-neutral-20 dark:bg-neutral-80 h-[48px]"></div>
                      <div className="flex h-fit w-fit items-center justify-between gap-2 overflow-hidden">
                        <div class="flex shrink-0 items-center">
                          <div
                            class="relative border flex w-fit shrink-0 items-center justify-center overflow-hidden rounded-full"
                            style={{ height: "40px", width: "40px" }}
                          >
                            <img
                              alt="Bitcoin logo"
                              loading="lazy"
                              width="40"
                              height="40"
                              decoding="async"
                              data-nimg="1"
                              class=""
                              style={{ color: "transparent" }}
                              src={currentProject?.logo}
                            />
                          </div>
                        </div>
                        <div class="truncate font-semibold text-neutral-100 dark:text-neutral-0 text-2xl">
                          {currentProject?.name}
                        </div>
                        <div class="flex min-w-0 shrink items-center gap-2">
                          <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs">
                            {currentProject?.symbol}
                          </div>
                          <div
                            className={`flex h-full items-center text-sm font-medium text-neutral-100 transition-colors  dark:text-neutral-0 text-score-good-background `}
                          >
                            {currentProject?.network === 56 ? (
                              <BscTokenIcon size={20} />
                            ) : currentProject?.network === 1 ? (
                              <EthTokenIcon size={20} />
                            ) : currentProject?.network === 69 ? (
                              <SolTokenIcon size={20} />
                            ) : currentProject?.network === 43114 ? (
                              <AvaxTokenIcon size={20} />
                            ) : currentProject?.network === 137 ? (
                              <PolygonTokenIcon size={20} />
                            ) : currentProject?.network === 42161 ? (
                              <ArbitrumTokenIcon size={20} />
                            ) : null}
                          </div>
                          <div class="flex min-w-0 shrink items-center">
                            <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs">
                              Pre-Launch
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="shrink-0 ">
            <div className="flex h-fit gap-2">buttons</div>
          </div>
        </div>
      </header>
      <header className="hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light dark:bg-background-dark sticky z-[1018] top-[5rem]">
        <div className="flex w-full flex-row items-end">
          <div className="max-w-full overflow-y-hidden overflow-x-scroll scroll-smooth scrollbar-hide pr-4">
            <div className="flex gap-6">
              <div role="none">
                <div
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "skynet"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "skynet" ? "true" : ""}
                  tabindex="0"
                  data-headlessui-state={
                    activeTab === "skynet" ? "checked" : ""
                  }
                  onClick={() => handleTabClick("skynet")}
                >
                  <span id="nav-skynet">Audit Overview</span>
                  {activeTab === "skynet" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("code-security")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "code-security"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "code-security" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "code-security" ? "checked" : ""
                  }
                >
                  <span id="nav-code-security">Security</span>
                  {activeTab === "code-security" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("fundamentals")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "fundamentals"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "fundamentals" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "fundamentals" ? "checked" : ""
                  }
                >
                  <span id="nav-fundamentals">Fundamentals</span>
                  {activeTab === "fundamentals" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("operations")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "operations"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "operations" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "operations" ? "checked" : ""
                  }
                >
                  <span id="nav-operations">Operations</span>
                  {activeTab === "operations" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("governance")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "governance"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "governance" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "governance" ? "checked" : ""
                  }
                >
                  <span id="nav-governance">Decentralisation</span>
                  {activeTab === "governance" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("market")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "market"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "market" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "market" ? "checked" : ""
                  }
                >
                  <span id="nav-market">Market</span>
                  {activeTab === "market" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
              <div role="none">
                <div
                  onClick={() => handleTabClick("community")}
                  className={`relative cursor-pointer whitespace-nowrap pb-2 text-base font-semibold transition-colors ui-checked:text-neutral-100 ui-checked:dark:text-neutral-0 ui-active:outline-none ui-active:outline-0 ${
                    activeTab === "community"
                      ? "text-neutral-100"
                      : "text-neutral-50"
                  }`}
                  role="radio"
                  aria-checked={activeTab === "community" ? "true" : ""}
                  tabindex="-1"
                  data-headlessui-state={
                    activeTab === "community" ? "checked" : ""
                  }
                >
                  <span id="nav-community">Community</span>
                  {activeTab === "community" && (
                    <div className="absolute bottom-0 left-0 h-[1px] w-full bg-neutral-100 dark:bg-neutral-0"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderProject;
